import SaveIcon from '@mui/icons-material/Save'
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography,
} from '@mui/material'
import { message as messageAntd, Table } from 'antd'
import { useCallback, useState } from 'react'

import { useDispatch } from 'react-redux'
import {
  closeModal,
  openModal,
} from '../../../../../../store/reducers/modal/modal.slice'
import CircularLoading from '../../../../../components/CircularProgress'
import ConfirmOrderModal from '../../../../../components/ConfirmOrderModal'
import UserSelectSearch from '../../../../../components/SelectSearch/UserSelectSearch'
import {
  ERRORS_MESSAGE_MAPPER,
  ERRORS_MESSAGE_MAPPER_DATA,
} from '../../../../../constants/errors'
import useAxios, { axiosInstance } from '../../../../../hooks/useAxios'
import { useRecipientPhoneRule } from '../../../../../hooks/useRecipientPhoneRule'
import { useUser } from '../../../../../hooks/useUser'
import { PaginationResponseInterface } from '../../../../../types/pagination'
import { IUserLists } from '../../../../../types/user'
import { AllowShippingProviderLists } from '../../../../../utils/provider'
import { IRemotesArea } from '../../../../../types/remote-area'
import { parseThaiAddress } from '../../../../../utils/address'
import { replaceMessage } from '../../../../../utils/message'
import { IOrder } from '../../../../../types/order'
import { PropertyList } from '../../../../../components/PropertyList'
import { PropertyListItem } from '../../../../../components/PropertyListItem'
import dayjs from 'dayjs'
import axios from 'axios'
import { IProduct } from '../../../../../types/product'
import { Tag } from '../../../../../components/Tag'
import { numberFormat } from '../../../../../utils'
import { EditOrderQuickCreateForm } from '../../../components/EditOrderQuickCreateForm'
import { resolveRecipientPhone } from '../../../../../utils/recipient-phone-rule.util'

interface IOrderListTeleSaleTableProps {
  isLoading: boolean
  onUpdateSuccess?: () => void
}
const initRemoteAdrea = {
  remote: {
    flash: false,
    kerry: false,
    jnt: false,
    spx: false,
    thaipost: false,
  },
  toure: {
    flash: false,
    kerry: false,
    jnt: false,
    spx: false,
    thaipost: false,
  },
}

interface AiPreviewData {
  name: string
  phone: string
  address: {
    address: string
    subDistrict: string
    district: string
    province: string
    zipcode: string
  }
  products: {
    name: string
    code: string
    quantity: number
    discount: 0
    size: string
  }[]
  social: string
  date: string
  paymentMethod: string
  note: string
}

const OrderQuickCreateOldCard = ({
  isLoading,
  onUpdateSuccess,
}: IOrderListTeleSaleTableProps) => {
  const dispatch = useDispatch()
  const { merchant } = useUser()
  const recipientPhoneRule = useRecipientPhoneRule()
  const [autoChangeAddress, setAutoChangeAddress] = useState<boolean>(false)
  const [submiting, setSubmitting] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [telesale, setTelesale] = useState<string>('')
  const [resetAutoComplete, setResetAutoComplete] = useState<string>('')
  const [searchUserTelesales, setSearchUserTelesales] = useState<string>('')
  const [checkRemote, setCheckRemote] = useState<boolean>(false)
  const [remoteArea, setRemoteArea] = useState<any>(initRemoteAdrea)
  const [previewData, setPreviewData] = useState<AiPreviewData>()
  const [editPreviewData, setEditPreviewData] = useState<any>()

  const userTelesalesList = useAxios<PaginationResponseInterface<IUserLists>>({
    method: 'GET',
    url: '/users/merchant',
    params: {
      page: 1,
      perPage: 5,
      search: searchUserTelesales,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchUserTelesales = async (value: string) => {
    setSearchUserTelesales(value)
    await userTelesalesList.mutate()
  }

  const handleCheckRemoteArea = useCallback(
    async (zipcode: string, subDistrict: string) => {
      const flashProvider = AllowShippingProviderLists(merchant).find(
        (provider) => provider.value === 'flash',
      )
      //console.log('flashProvider', flashProvider)
      if (!flashProvider) {
        setCheckRemote(true)
        await handleCreateOrder()
        return
      }

      if (!zipcode || !subDistrict) {
        if (!zipcode) {
          messageAntd.error('ข้อมูลที่ถูกต้อง ไม่พบข้อมูลรหัสไปรษณีย์')
        }
        if (!subDistrict) {
          messageAntd.error('ข้อมูลที่ถูกต้อง ไม่พบข้อมูลตำบล/แขวง')
        }
        return
      }

      try {
        const { data } =
          await axiosInstance.get<IRemotesArea>('/remote-area/flash')
        const isRemote = data.remotes.find(
          (remote) =>
            remote.subdistrict === subDistrict && remote.zipcode === zipcode,
        )
        const isTour = data.tours.find(
          (remote) =>
            remote.subdistrict === subDistrict && remote.zipcode === zipcode,
        )
        setRemoteArea({
          ...remoteArea,
          remote: {
            ...remoteArea.remote,
            flash: !!isRemote,
          },
          tour: {
            ...remoteArea.toure,
            flash: !!isTour,
          },
        })
        let title = ''
        if (isRemote) {
          title =
            'ที่อยู่นี้เป็นพื้นที่ห่างไกลของ flash ต้องการสร้างคำสั่งซื้อใช่หรือไม่?'
        } else if (isTour) {
          title =
            'ที่อยู่นี้เป็นพื้นที่ท่องเที่ยวของ flash ต้องการสร้างคำสั่งซื้อใช่หรือไม่?'
        }
        if (title) {
          dispatch(
            openModal({
              title,
              content: (
                <ConfirmOrderModal
                  onConfirm={async () => {
                    await handleCreateOrder()
                  }}
                />
              ),
            }),
          )
          return
        }
      } catch (e) {
        return
      }
      await handleCreateOrder()
      setCheckRemote(false)
    },
    [remoteArea, merchant],
  )

  const handleCreateOrder = async () => {
    let duplicateOrder
    try {
      const split =
        message
          ?.trim()
          ?.split('=')
          ?.map((line) => line?.trim()?.replaceAll('\n', '')) ?? []

      const name = split?.[1] ?? ''
      const rawPhone = split?.[7] ?? ''

      if (!name || !rawPhone) {
        messageAntd.error('ข้อความไม่ถูกต้อง')
        return
      }

      const { check: phoneCheck, phone } = resolveRecipientPhone(
        rawPhone,
        recipientPhoneRule,
      )
      if (phoneCheck.status === 'invalid') {
        messageAntd.error(phoneCheck.message)
        return
      }

      duplicateOrder = await axiosInstance.post<{
        isDuplicate: boolean
        duplicate: IOrder[]
      }>('/order/check/duplicate', {
        name,
        phone,
        day: merchant.config?.dulplicateOrderDate ?? 1,
      })
    } catch (e: unknown) {
      messageAntd.error('เกิดข้อผิดพลาด ไม่สามารถตรวจสอบคำสั่งซื้อซ้ำได้')
      return
    }

    if (duplicateOrder?.data?.isDuplicate) {
      dispatch(
        openModal({
          title: 'คุณเคยสร้างคำสั่งซื้อนี้แล้วคุณต้องการสร้างซ้ำหรือไม่?',
          width: 500,
          content: (
            <ConfirmOrderModal
              content={
                <Box>
                  <Typography mb={3}>รายละเอียดคำสั่งซื้อที่ซ้ำกัน:</Typography>
                  {duplicateOrder?.data?.duplicate?.map((order) => (
                    <PropertyList>
                      <PropertyListItem
                        align={`horizontal`}
                        label="รหัสคำสั่งซื้อ"
                      >
                        <a
                          href={`/orders/detail/${order.objectId}`}
                          target="_blank"
                        >
                          {order.code.toString()}
                        </a>
                      </PropertyListItem>
                      <Divider />
                      <PropertyListItem
                        align={`horizontal`}
                        label="วันที่คำสั่งซื้อ"
                        value={`${dayjs(order.orderDate).format('DD/MM/YYYY')}`}
                      />
                      <Divider />
                      <PropertyListItem
                        align={`horizontal`}
                        label="วันที่สร้าง"
                        value={`${dayjs(order.createdAt).format(
                          'DD/MM/YYYY HH:mm',
                        )}`}
                      />
                      <Divider />
                      <PropertyListItem
                        align={`horizontal`}
                        label="ชื่อผู้รับสินค้า"
                        value={order.recipient.name}
                      />
                      <Divider />
                      <PropertyListItem
                        align={`horizontal`}
                        label="หมายเลขโทรศัพท์"
                        value={order.recipient.phone}
                      />
                      <Divider />
                      <PropertyListItem
                        align={`horizontal`}
                        label="ช่องทางการขาย"
                        value={order.distribution?.name ?? '-'}
                      />
                    </PropertyList>
                  ))}
                </Box>
              }
              onConfirm={async () => {
                await handleCheckBlacklist()
                //dispatch(closeModal())
              }}
            />
          ),
        }),
      )
      return
    }
    await handleCheckBlacklist()
    return
  }

  const handleCheckBlacklist = async () => {
    try {
      const split =
        message
          ?.trim()
          ?.split('=')
          ?.map((line) => line?.trim()?.replaceAll('\n', '')) ?? []

      const name = split?.[1] ?? ''
      const rawPhone = split?.[7] ?? ''

      if (!name || !rawPhone) {
        messageAntd.error('ข้อความไม่ถูกต้อง')
        return
      }

      const { phone: phoneNumber } = resolveRecipientPhone(
        rawPhone,
        recipientPhoneRule,
      )

      const responseCustomerWarning = await axiosInstance.post(
        '/blacklists/checking',
        {
          name,
          phoneNumber,
          ignoreName: true,
        },
      )
      if (responseCustomerWarning.data.blacklist) {
        dispatch(
          openModal({
            title: `เตือน! ลูกค้า ${name} อยู่ในรายการ Blacklist`,
            width: 500,
            content: (
              <ConfirmOrderModal
                onConfirm={async () => {
                  await createOrder()
                  //dispatch(closeModal())
                }}
              />
            ),
          }),
        )
        return
      }
      await createOrder()
      setRemoteArea(initRemoteAdrea)
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      messageAntd.error(messageError)
      // messageAntd.error('เกิดข้อผิดพลาด ไม่สามารถสร้างคำสั่งซื้อได้')
    }
  }

  const createOrder = async () => {
    setSubmitting(true)
    try {
      const response = await axiosInstance.post('/order/order-message', {
        message: message.trim(),
        telesaleBy: telesale,
      })
      messageAntd.success(response.data.message)
      onUpdateSuccess && onUpdateSuccess()
      setResetAutoComplete(new Date().getTime().toString())
      setMessage('')
      setSearchUserTelesales('')
      setTelesale('')
      setSubmitting(false)
    } catch (e: any) {
      const { data } = e.response?.data
      let messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        e.response?.data?.message ||
        'บันทึกข้อมูลไม่สำเร็จ'

      if (data) {
        const errorDataMessage: string[] = []
        Object.keys(data).forEach((key) => {
          errorDataMessage.push(
            `${ERRORS_MESSAGE_MAPPER_DATA?.[key] ?? 'ข้อมูลที่ถูกต้อง'}: ${
              data[key]
            }`,
          )
        })
        if (autoChangeAddress && data?.bestMatch) {
          const msg = replaceMessage(
            message,
            e.response?.data?.message ?? '',
            data?.bestMatch,
          )
          setMessage(msg)
        }
        messageError += `, ${errorDataMessage.join(', ')}`
      }
      messageAntd.error(messageError)
      setSubmitting(false)
    }
    dispatch(closeModal())
  }

  const handleAiExtractMessage = useCallback(async () => {
    setSubmitting(true)
    try {
      const response = await axios.post<AiPreviewData>(
        'https://n8n.systemtong.com/webhook/order',
        {
          message,
          merchant: merchant.prefix,
        },
      )
      const data = response.data

      const responseBlacklist = await axiosInstance.post(
        '/blacklists/checking',
        {
          name: data.name,
          phoneNumber: data.phone,
          ignoreName: true,
        },
      )

      const isBlacklist = responseBlacklist?.data?.blacklist

      const products = []
      for (const product of data.products) {
        const response = await axiosInstance.get<IProduct[]>('/product-ai', {
          params: {
            merchant: merchant.prefix,
            search: product.code || product.name,
          },
        })
        const productsData = response.data
        if (!productsData.length) {
          messageAntd.error(`ไม่พบสินค้า ${product.code || product.name}`)
          setSubmitting(false)
          return
        }
        products.push({
          objectId: productsData[0].objectId,
          name: productsData[0].name,
          price: productsData[0].price,
          quantity: product.quantity,
          discount: product.discount || 0,
          free: false,
        })
      }

      if (!products.length) {
        messageAntd.error(`ไม่พบรายการสินค้า`)
        setSubmitting(false)
        return
      }

      const payload = {
        ...data,
        products,
      }

      // console.log('payload', payload)

      setPreviewData(data)
      if (data) {
        dispatch(
          openModal({
            title: 'ยืนยันการนำเข้าข้อมูล?',
            width: 800,
            content: (
              <>
                <EditOrderQuickCreateForm
                  products={products}
                  isBlacklist={isBlacklist}
                  data={data}
                  onConfirm={async (form) => {
                    await handleAiCreateOrder(form)
                    //dispatch(closeModal())
                  }}
                />
                {/* <ConfirmOrderModal
                  content={<Box></Box>}
                  onConfirm={async () => {
                    await handleAiCreateOrder(payload)
                    //dispatch(closeModal())
                  }}
                /> */}
              </>
            ),
          }),
        )
      }
    } catch (e) {}
    setSubmitting(false)
  }, [message, submiting, merchant])

  const handleAiCreateOrder = async (values: Record<string, any>) => {
    setSubmitting(true)
    try {
      await axiosInstance.post('/order', {
        name: values.name,
        phone: values.phone,
        address: {
          address: values.address.address.trim() as string,
          subDistrict: values.address.subDistrict.trim() as string,
          district: values.address.district.trim() as string,
          province: values.address.province.trim() as string,
          zipcode: `${values.address.zipcode}`.trim(),
        },
        social: values.social.trim() as string,
        isCOD: values.paymentMethod === 'COD',
        products: values.products.map((product: any) => ({
          objectId: product.objectId,
          quantity: product.quantity,
          discount: product.discount,
          size: product.size ?? '',
          free: product.isFree === 'yes',
        })),
        orderDate: values.date ?? '',
        note: values.note ?? '',
      })
      onUpdateSuccess && onUpdateSuccess()
      setResetAutoComplete(new Date().getTime().toString())
      setMessage('')
      setSearchUserTelesales('')
      setTelesale('')
      setSubmitting(false)
      messageAntd.success('สร้างสินค้าสำเร็จ')
      dispatch(closeModal())
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      messageAntd.error(messageError)
      console.log(e)
      setSubmitting(false)
    }
  }

  return (
    <>
      <CircularLoading isLoading={isLoading || submiting} />
      <Grid item xs={12} lg={12}>
        <Card sx={{ padding: 2 }}>
          <Typography variant={'h6'} mb={2}>
            สร้างคำสั่งซื้อ ด่วน
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <TextField
                fullWidth
                autoFocus={true}
                label={`คำสั่งซื้อ`}
                multiline
                value={message}
                placeholder={`=ลำดับ(ถ้ามี).ชื่อ นามสกุล
=ชื่อสินค้า/ขนาด/จำนวน/ส่วนลด/สถานะฟรี (ไม่จำเปนต้องกรอก ถ้าไม่ฟรี)
=รูปแบบการชำระ (COD หรือ BANK)/ราคารวมของสินค้าที่ขาย
=ที่อยู่ ต.ชือตำบล ,อ.ชื่ออำเภอ
=ชื่อจังหวัด
=รหัสไปรษณีย์
=หมายเลขโทรศัพท์
=ชื่อเฟสบุ๊ค
=Username ของคนขายสินค้าได้
=ช่องทางการขาย
=วันที่ย้อนหลัง
                                                        
                      `}
                rows={14}
                onChange={(e) => setMessage(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={autoChangeAddress}
                    onChange={(e) => {
                      setAutoChangeAddress(e.target.checked)
                    }}
                    name="autoChangeAddress"
                  />
                }
                label="เปิดใช้การงาน เปลี่ยนที่อยู่อัตโนมัติจากข้อมูลที่ใกล้เคียง"
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              {Object.keys(remoteArea.remote).map((key: string) => {
                if (remoteArea.remote?.[key]) {
                  return (
                    <Typography fontSize={14} color={'error'}>
                      ** ที่อยู่นี้เป็นพื้นที่ห่างไกลของ {key.toUpperCase()} **
                    </Typography>
                  )
                }
                if (remoteArea.tour?.[key]) {
                  return (
                    <Typography fontSize={14} color={'error'}>
                      ** ที่อยู่นี้เป็นพื้นที่ท่องเที่ยวของ {key.toUpperCase()}{' '}
                      **
                    </Typography>
                  )
                }
                return <></>
              })}
            </Grid>
            <Grid item xs={12} lg={12}>
              {/* <SelectSearch<IUserLists>
                resetAutoComplete={resetAutoComplete}
                label={
                  'เลือกผู้ดูแล Telesale (กรุณาเว้นว่างไว้ หากไม่ต้องการกำหนด)'
                }
                onSelect={(e) => setTelesale(e!.value.name || '')}
                search={searchUserTelesales}
                onSearch={handleSearchUserTelesales}
                options={
                  userTelesalesList.data?.records
                    .filter(
                      (userTelesales: IUserLists) => userTelesales.isAvailable,
                    )
                    .map((userTelesales: IUserLists) => ({
                      label: userTelesales.name,
                      image: userTelesales.image,
                      value: userTelesales,
                    })) || ([] as IOptionSelect<IUserLists>[])
                }
              /> */}

              <UserSelectSearch
                resetAutoComplete={resetAutoComplete}
                label={
                  'เลือกผู้ดูแล Telesale (กรุณาเว้นว่างไว้ หากไม่ต้องการกำหนด)'
                }
                onSelect={(e) => setTelesale(e!.value.name || '')}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              {checkRemote ? (
                <Button
                  disabled={submiting}
                  startIcon={
                    submiting ? <CircularProgress size={18} /> : <SaveIcon />
                  }
                  onClick={handleCreateOrder}
                  fullWidth
                  variant={'contained'}
                >
                  สร้างคำสั่งซื้อ
                </Button>
              ) : (
                <Button
                  disabled={submiting}
                  startIcon={
                    submiting ? <CircularProgress size={18} /> : <SaveIcon />
                  }
                  onClick={() => {
                    const formatter = message
                      .split('=')
                      .map((line) => line.replaceAll('\n', '').trim())
                    const address = `${formatter?.[4] ?? ''} จ.${
                      formatter?.[5] ?? ''
                    }  ${formatter?.[6] ?? ''} `
                    const { subDistrict, zipcode } = parseThaiAddress(address)
                    handleCheckRemoteArea(zipcode, subDistrict)
                  }}
                  fullWidth
                  variant={'contained'}
                >
                  สร้างคำสั่งซื้อ*
                </Button>
              )}

              {/* <Button
                sx={{ mt: 1, display:'none' }}
                color="error"
                disabled={submiting}
                startIcon={
                  submiting ? <CircularProgress size={18} /> : <SaveIcon />
                }
                onClick={handleAiExtractMessage}
                fullWidth
                variant={'contained'}
              >
                สร้างคำสั่งซื้อ แบบใหม่
              </Button> */}
            </Grid>
            <Grid item xs={12} lg={12}>
              <Typography variant={'subtitle1'} color={'text.primary'} mb={1}>
                ตัวอย่าง
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  flex: 1,
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant={'subtitle2'} color={'text.primary'}>
                    =ลำดับ(ถ้ามี).ชื่อ นามสกุล <br />
                    =ชื่อสินค้า/ขนาด/จำนวน/ส่วนลด/สถานะฟรี (ไม่จำเปนต้องกรอก
                    ถ้าไม่ฟรี) <br />
                    =รูปแบบการชำระ (COD หรือ BANK)/ราคารวมของสินค้าที่ขาย <br />
                    =ที่อยู่ ต.ชือตำบล ,อ.ชื่ออำเภอ <br />
                    =ชื่อจังหวัด <br />
                    =รหัสไปรษณีย์ <br />
                    =หมายเลขโทรศัพท์ <br />
                    =ชื่อเฟสบุ๊ค <br />
                    =Username ของคนขายสินค้าได้ <br />
                    =ช่องทางการขาย <br />
                    =วันที่ย้อนหลัง
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant={'subtitle2'} color={'text.primary'}>
                    =1.มองคล มองไกลมาก <br />
                    =RP2/0/1/0 หรือ RP2/0/1/0/free <br />
                    =COD/349 หรือ BANK/349 <br />
                    =10/3 หมู่ 4 ถนนเอก ต.หนองจะบก, อ.เมืองนครราชสีมา <br />
                    =นครราชสีมา <br />
                    =30000 <br />
                    =0800000001 <br />
                    =มองคล มองไกลมาก <br />
                    =admin <br />
                    =เพจขายสินค้า <br />
                    =2023-03-01
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  )
}

export default OrderQuickCreateOldCard
